import {
  BUSINESS_TYPES_MASP_COMPONENT, RENTAL, USED,
} from '@/utils/constants/filters'

const businessTypeMixin = {
  data () {
    return {
      businessTypeOptions: BUSINESS_TYPES_MASP_COMPONENT,
      businessValue: BUSINESS_TYPES_MASP_COMPONENT[0].value,
    }
  },

  methods: {
    $_update_business (currentBusiness) {
      const { listingType, business } = this.$_mount_businessType_object(currentBusiness)

      const constructionStatus = this.constructionStatus || ''

      return {
        business,
        listingType,
        constructionStatus: business === RENTAL ? '' : constructionStatus,
      }
    },

    $_mount_businessType_object (currentBusiness) {
      const businessType = {
        business: currentBusiness,
        listingType: USED,
      }

      return businessType
    },
  },
}

export default businessTypeMixin
